<template>
  <v-card>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex lg6 xs12>
            <v-text-field :label="labels.name" v-model="quoteForm.name" :error-messages="errors.collect('name')" v-validate="'max:128|name'" data-vv-name="name" :data-vv-as="labels.name" prepend-icon="mdi-comment-account"></v-text-field>
          </v-flex>
          <v-flex lg6 xs12>
          </v-flex>
          <v-flex lg6 xs12>
            <v-text-field :label="labels.phone" v-model="quoteForm.phone" :error-messages="errors.collect('phone')" v-validate="'numeric|max:20'" data-vv-name="phone" :data-vv-as="labels.phone" prepend-icon="mdi-phone"></v-text-field>
          </v-flex>
          <v-flex lg6 xs12>
            <v-text-field :label="labels.email" v-model="quoteForm.email" type="email" :error-messages="errors.collect('email')" v-validate="'email'" data-vv-name="email" :data-vv-as="labels.email" prepend-icon="mdi-email"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" flat="flat" @click.native="doCancel">Cancel</v-btn>
      <v-btn color="primary" flat="flat" type="submit" @click="doSave" :loading="$store.state.agency.quotation.saving">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { AGENCY_SALES_EDIT } from '@/store/types'
// As local state management is quite hard to share between components, we will duplicate some info from SalesOpportunity.vue
// Validation and data to follow exact format of SalesOpportunity.vue
export default {
  data() {
    return {
      labels: {
        name: 'Name',
        email: 'Email',
        phone: 'Contact No'
      },
      quoteForm: {
        name: undefined,
        email: undefined,
        phone: undefined
      }
    }
  },
  computed: {
    salesOppoState() {
      return this.$store.state.agency.quotation.commonForm
    }
  },
  methods: {
    init() {
      this.quoteForm.name = this.salesOppoState.salesOppName
      this.quoteForm.email = this.salesOppoState.salesOppEmail
      this.quoteForm.phone = this.salesOppoState.salesOppPhone
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(AGENCY_SALES_EDIT, this.quoteForm)
          this.$emit('close')
          this.$store.dispatch('saveQuote')
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      // revert the state
      this.init()
      this.$emit('close')
    }
  },
  mounted() {
    // Load state
    this.init()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
